module.exports = __webpack_public_path__ + "img/appstore.32ecb6a8.png";